import React from 'react';
import {FlatList, ListRenderItemInfo, View} from 'react-native';

import NavigationHeader from '/component/layout/NavigationHeader';
import {keyExtractor} from '/component/screen/ReleaseNotes/ReleaseNotes.util';
import {Modal} from '/constant/TestIDs';

import {Note} from './Note';
import {useReleaseNotes} from './ReleaseNotes.hook';
import {styles} from './ReleaseNotes.style';

interface ReleaseNotesProps {
  releaseNotes: string | Record<string, any>;
  safeAreaInsets: {top: number; bottom: number; left: number; right: number};
}

export const ReleaseNotes: React.FC<ReleaseNotesProps> = ({
  releaseNotes = '',
  safeAreaInsets = {top: 0, bottom: 0, left: 0, right: 0},
}) => {
  const {tt, parseReleaseNotes} = useReleaseNotes({releaseNotes});

  const separatorComponent = () => <View style={styles.separator} />;

  const renderItem = ({item}: ListRenderItemInfo<any>) => <Note item={item} />;

  const headerStyle = safeAreaInsets ? {paddingTop: safeAreaInsets.top} : {};

  return (
    <NavigationHeader
      testID={Modal.whatsNewModal}
      title={tt('whatsNew?', 'What’s new?')}
      style={{
        base: styles.base,
        iconLeft: styles.icon,
        header: styles.navigationContainer,
        title: styles.title,
        ...headerStyle,
      }}>
      <FlatList
        keyExtractor={keyExtractor}
        style={styles.contentContainer}
        invertStickyHeaders={true}
        data={parseReleaseNotes}
        showsVerticalScrollIndicator={false}
        renderItem={renderItem}
        ItemSeparatorComponent={separatorComponent}
      />
    </NavigationHeader>
  );
};
